import React, {  useState } from 'react';
import useApiAgenda from "../../api/catalogos/useApiAgenda";
import Filtro from "../../shared/componentes/filtro";
import FiltroAgenda from "../Agenda/FiltroAgenda";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import AgendaDetalle from "../Agenda/AgendaDetalle";
import AgendaNuevo from "../Agenda/AgendaNuevo"; // Nuevo componente que crearemos
import { Sidebar } from 'primereact/sidebar';
import useSeguridad from "../../Seguridad/useSeguridad";
import constantes from "../constantes";
import { getSessionState } from "../../hooks/useSessionState";
const Agenda=()=>{
    const seguridad = useSeguridad();
    const filtroKey = 'filtrosEmpleados';
    const [gridApi] = useState(null);
    const api = useApiAgenda();
    const [datos, setDatos] = useState(null);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [sidebarNuevoVisible, setSidebarNuevoVisible] = useState(false); // Estado para el sidebar de nuevo usuario
    const soloLectura = !seguridad.esEditable(constantes.menus.puestos);
    const [id, setEquipo] = useState(false);    
    const obtenerFiltro = (filtro) => {
        filtro = filtro ?? getSessionState(filtroKey);
        return {
            ...filtro
        };
    };
    const permisoCrearPermisionarios = seguridad.tieneAcceso(constantes.opciones.permisoPermisionariosAgenda); //permisionarios
    const permisoGuardarAgenda = seguridad.tieneAcceso(constantes.opciones.permisoGuardarAgenda);
    async function buscar(filtro, paramsApi) {
         let datos = await api.filtrar(obtenerFiltro(filtro));
         setDatos(datos);
    }
    const verTelefonos = (id) => {
        setSidebarVisible(true);
        setEquipo(id);
    };

    const agregarNuevo = () => {

        setSidebarNuevoVisible(true);
    };

    const RowButtons = ({ data }) => (
        <div className="d-flex justify-content-end">
           <ButtonIcon title={'Editar'} iconName={'FaRegEdit'} className={'text-primary'}  onClick={() => verTelefonos(data.id)}/>
        </div>
    );

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h2>Agenda</h2>
            </div>

            <div className="d-flex align-items-center gap-3 mb-3">
                <div className="flex-grow-1">
                <Filtro filtroKey={filtroKey} handleSubmit={buscar} defaultValue={{ nombre: '' }} gridApi={gridApi}
                    classButtons="field-iconos btn-group">
                    <FiltroAgenda />
                </Filtro>
                </div>
                {(permisoCrearPermisionarios) && 
                    <button 
                        className="btn btn-primary flex-shrink-0 align-self-start"
                        onClick={agregarNuevo}
                    >
                        <i className="pi pi-plus mr-2"></i>
                        Permisionario
                    </button>
                }
            </div>            

            {/* Sidebar para editar usuario existente */}
            <Sidebar visible={sidebarVisible} position="right" dismissable={false} className="p-sidebar-xl"
                onHide={() => setSidebarVisible(false)}>
                <AgendaDetalle empleadoid={id} onSave={buscar} name="datosGenerales"
                    close={() => setSidebarVisible(false)} soloLectura={soloLectura} />
            </Sidebar>

            {/* Sidebar para agregar nuevo usuario */}
            <Sidebar visible={sidebarNuevoVisible} position="right" dismissable={false} className="p-sidebar-xl"
                onHide={() => setSidebarNuevoVisible(false)}>
                <AgendaNuevo 
                    onSave={() => {
                        setSidebarNuevoVisible(false);
                        buscar(); // Refrescar la lista
                    }}
                    close={() => setSidebarNuevoVisible(false)} 
                />
            </Sidebar>

            <div className="table-custom">
                <table className="table table-sm table-striped table-fixed"
                    style={{ height: '98%' }}>
                    <thead>
                        <tr>
                            <th style={{ width: 100 }}>Nombres</th>
                            <th style={{ width: 800 }}>Linea ABC</th>
                            {(permisoGuardarAgenda) &&
                              <th style={{ width: 120 }}>Linea Personal</th>          
                            }                                
                            <th className="center">
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {datos?.map((item, index) => {
                          return (
                                <tr key={index} >
                                    <td style={{ width: 400 }}>{item.nombre}</td>                                   
                                    <td style={{ width: 200 }}>{item.telefonoAbc}</td>                                  
                                    {(permisoGuardarAgenda) &&
                                         <td className="text-center">{item.telefonoPersonal}</td>

                                    }
                                    <td>
                                        <RowButtons data={item} />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default Agenda;